import React from 'react';
import './goLive.css'; // Import the CSS file

const GoLive = () => {
  return (
    <div id="goLive" className="goLive-animation"></div>
  );
}

export default GoLive;